<template>
  <div class="staff_import">
    <el-page-header @back="goBack" title content="员工导入"></el-page-header>
    <div class="staff_import_form">
      <el-form ref="form" :model="form" label-width="100px">
        <el-form-item label="员工信息表:">
          <div class="el-upload el-upload--text" ref="triggerArea" @click="triggerUpload">
            <div class="el-upload-dragger" v-if="!form.file">
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖到此处，或
                <em>点击上传</em>
              </div>
            </div>
            <div class="el-upload-dragger" v-else>
              <div class="file_name">
                <i class="iconfont icon-lianjie"></i>
                {{form.file.name}}
              </div>
            </div>
            <input type="file" hidden ref="upload" @change="upload" />
            <!-- <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div> -->
          </div>
        </el-form-item>
        <el-form-item label="操作:">
          <el-button @click="goBack">取消</el-button>
          <el-button type="primary" @click="submit">确定</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: "StaffImport",
  data() {
    return {
      form: {
        file: null
      }
    };
  },
  mounted: function() {
    this.addDragEventListener();
  },
  methods: {
    goBack: function() {
      this.$router.go(-1);
    },
    triggerUpload: function() {
      this.$refs.upload.click();
    },
    upload: function(e) {
      this.form.file = e.target.files[0];
    },
    submit: function() {
      if (!this.form.file) {
        this.$message({
          message: "请上传员工信息表文件",
          type: "error"
        });
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      let formData = new FormData();
      formData.append("file", this.form.file);
      this.$api
        .post(`/xsss/v1/staff/import`, formData)
        .then(() => {
          loading.close();
          this.$message({
            message: "导入成功",
            type: "success"
          });
        })
        .catch(() => {
          loading.close();
        });
    },
    addDragEventListener: function() {
      let dropZone = this.$refs.triggerArea;
      dropZone.addEventListener(
        "dragenter",
        e => {
          e.preventDefault();
          e.stopPropagation();
        },
        false
      );

      dropZone.addEventListener(
        "dragover",
        e => {
          e.preventDefault();
          e.stopPropagation();
        },
        false
      );

      dropZone.addEventListener(
        "dragleave",
        e => {
          e.preventDefault();
          e.stopPropagation();
        },
        false
      );

      dropZone.addEventListener(
        "drop",
        e => {
          e.preventDefault();
          e.stopPropagation();
          // 处理拖拽文件的逻辑
          this.drag(e);
        },
        false
      );
    },
    drag: function(e) {
      var df = e.dataTransfer;
      if (df.items !== undefined) {
        // 用webkitGetAsEntry禁止上传目录
        var item = df.items[0];
        if (item.kind === "file" && item.webkitGetAsEntry().isFile) {
          var file = item.getAsFile();
          this.form.file = file;
        }
      } else {
        this.form.file = df.files[0];
      }
    }
  }
};
</script>

<style  scoped>
@import url("./index.css");
</style>